import { Coding, Location, Practitioner, Reference } from '@medplum/fhirtypes';
import { AMBULATORY_ENCOUNTER_CLASS_CODING } from '@bariendo/lib/codings';

export interface ValidationResult {
  valid: boolean;
  error?: string;
}

export interface SharedFields {
  practitioner: Reference<Practitioner> | null;
  timezone: string;
  encounterClass: Coding;
  location: Reference<Location> | null;
}

/**
 * Validates shared availability fields (practitioner, timezone, location when in-person)
 * Used by both WeeklyAvailabilityForm and OneTimeAvailabilityForm
 */
export function validateSharedAvailabilityFields(fields: SharedFields): ValidationResult {
  if (!fields.practitioner) {
    return { valid: false, error: 'Provider is required' };
  }

  if (!fields.timezone) {
    return { valid: false, error: 'Time zone is required' };
  }

  const isInPerson = fields.encounterClass.code === AMBULATORY_ENCOUNTER_CLASS_CODING.code;
  if (isInPerson && !fields.location) {
    return { valid: false, error: 'Location is required for in-person visits' };
  }

  return { valid: true };
}
